"use client";

import Link from "next/link";

import type { TenantCode } from "@/config/tenants";
import { authCopy } from "@/features/auth/content/auth-copy";
import { useAppLocale } from "@/features/localization/app-locale-provider";

export function AuthLegalLinks({ tenantCode }: { tenantCode: TenantCode }) {
  const { locale } = useAppLocale();
  const copy = authCopy[locale];
  const newTabSuffix = locale === "fr" ? "(s’ouvre dans un nouvel onglet)" : "(opens in a new tab)";
  const linkClassName =
    "font-medium text-primary underline underline-offset-2 focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

  return (
    <p className="text-center text-xs leading-5 text-muted-foreground">
      {copy.signIn.legalPrefix}{" "}
      <Link
        aria-label={`${copy.signIn.terms} ${newTabSuffix}`}
        className={linkClassName}
        href={`/${tenantCode}/terms`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span aria-hidden="true">{copy.signIn.terms}</span>
      </Link>{" "}
      &amp;{" "}
      <Link
        aria-label={`${copy.signIn.privacy} ${newTabSuffix}`}
        className={linkClassName}
        href={`/${tenantCode}/privacy`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span aria-hidden="true">{copy.signIn.privacy}</span>
      </Link>
      .
    </p>
  );
}
